import { PlusIcon } from '@heroicons/react/24/outline';
import type { ReactNode } from 'react';

interface PracticeMetaCellProps {
    label: string;
    children?: ReactNode;
    missing?: boolean;
    onAdd?: () => void;
}

export function PracticeMetaCell({ label, children, missing, onAdd }: PracticeMetaCellProps) {
    return (
        <div className="min-w-0">
            <span className="block text-[11px] font-bold text-gray-400 uppercase tracking-[0.04em]">
                {label}
            </span>
            {missing ? (
                <button
                    type="button"
                    onClick={onAdd}
                    className="mt-1 inline-flex items-center gap-1 text-[13px] font-medium text-gray-400 hover:text-gray-700"
                >
                    <PlusIcon className="h-3 w-3" />
                    Add {label.toLowerCase()}
                </button>
            ) : (
                <span className="block text-[14px] text-gray-800 truncate mt-1">{children}</span>
            )}
        </div>
    );
}
